import { hrBaseApi } from "app/services/HrBaseApi";

export const LateCheckinApis = hrBaseApi.injectEndpoints({
  endpoints: (builder) => ({

    /* ================= LATE CHECKIN LIST ================= */
    LateCheckinListAPI: builder.query({
      query: ({ start_date, end_date, page = 1 }) => ({
        url: `/Felix/LateCheckinListAPI/`,
        method: "GET",
        params: {
          start_date,
          end_date,
          page,
        },
      }),
      providesTags: ["LateCheckinList"],
    }),

  }),
});

/* ----- EXPORT HOOK ----- */
export const {
  useLateCheckinListAPIQuery,
} = LateCheckinApis;
